<template>
    <div class="text-center">
        <span
            v-if="hasComment"
            v-b-tooltip.hover
            :title="`Comment: ${value}`"
            >{{ $t("View") }}</span
        >
        <b-modal v-model="dialog" :title="dialogTitle" :hide-footer="true">
            {{ value }}
        </b-modal>
    </div>
</template>

<script>
export default {
  name: "",
  data: function() {
    return {
      collections: [],
      hotInstance: null,
      TD: null,
      row: null,
      col: null,
      prop: null,
      value: null,
      cellProperties: null,
      dialog: false,
      dialogTitle: ""
    };
  },
  computed: {
    hasComment() {
      return this.value ? true : false;
    }
  },
  // mounted() {
  //     if (this.hasComment) {
  //         this.TD.addEventListener("click", this.openDialog);
  //     }
  // },
  methods: {
    openDialog() {
      let poNumber = this.hotInstance.getDataAtRowProp(this.row, "po_number");
      this.dialogTitle = `PO ${poNumber} - Row comment`;
      this.dialog = true;
    }
  }
};
</script>
